export default __webpack_public_path__ + "static/media/portfolioservice.e93f2968.svg";